module.exports = __webpack_public_path__ + "static/noticias-18-c19ba11032feb62b158622fd3efde4e3.jpg";